import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'

import styles from './WrapSection.module.scss'

import { EffectSection } from '../EffectSection/EffectSection'

export const WrapSection = (props) => {
  const sectionRef = useRef(null)
  const [effectParent, setEffectParent] = useState(null)

  useEffect(() => {
    setEffectParent(sectionRef.current)
  }, [sectionRef])

  return (
    <div
      className={classNames(
        'wrap-section',
        styles['wrap-section'],
        {
          [styles['wrap-section--'+props.color]]: props.color,
          [[styles['wrap-section--spt']]]: props['small-padding-top'],
        }
      )}
      ref={el => sectionRef.current = el}
    >
      {effectParent && 
        <EffectSection
          parent={effectParent}
          quantity={props.color === 'black' ? 2 : 4}
          theme={props.color}
        />
      }
      {props.children}
    </div>
  )
}